module.exports = "<template>\r\n    <div show.bind=\"show\">\r\n        <div class=\"gap\"></div>\r\n        <slot></slot>\r\n    </div>\r\n</template>";